import { useEffect } from 'react';
import Preloader from "../components/Preloader";
import AlicjaMenu from "../components/header/menu/AlicjaMenu";
import MainScrollBar from "./MainScrollBar";
import CustomCursor from "./CustomCursor";

function Layout({ className, children, tag: Tag = 'div', activeScrollbar = false, ...rest }) {
  useEffect(() => {
    const loader = document.querySelector('.preloader');
    const finish = () => {
      // ensure we’re on the next frame so the transition fires
      requestAnimationFrame(() => loader.classList.add('loaded'));
    };

    if (document.readyState === 'complete') {
      finish();
    } else {
      window.addEventListener('load', finish, { once: true });
    }
  }, []);

  return (
    <>
      <Preloader />  {/* always in the DOM */}
      <Tag id="main_layout" className={className}>
        <AlicjaMenu hamburger />
        {activeScrollbar
          ? <MainScrollBar {...rest}>{children}</MainScrollBar>
          : children}
        <CustomCursor
          duration={0.5}
          durationChangeSize={0.3}
          size={30}
          scale={75}
          ease="power2.out"
        />
      </Tag>
    </>
  );
}

export default Layout;
